import moment from "moment";

function getPriorityQuantityTotal(alarms) {
    let priority = []
    for (let i = 0; i < 3; i++) {
        let sum = 0;
        alarms.forEach(alarm => {
            if (alarm.state == i) sum++;
        });
        priority.push(sum)
    }
    return { high: priority[0], medium: priority[1], low: priority[2] }
}

function getPlantAlarms(id, alarmsReceived) {
    let alarm
    let total = []
    if (id[0] == 'all') return getAlarms(alarmsReceived);
    id.forEach(plantId => {
        alarm = alarmsReceived.find(e => e.id == plantId)
        if (alarm) {
            alarm.alarms.forEach(element => {
                total.push(element)
            });
            alarm.equipments.forEach(element => {
                element.alarms.forEach(element => {
                    total.push(element)
                });
            });
        }
    });
    return total
}
function getAlarms(alarmsReceived) {
    let alarms = []

    alarmsReceived.forEach(plant => {
        plant.alarms.forEach(alarm => {
            alarms.push(alarm)
        });
        plant.equipments.forEach(equipment => {
            equipment.alarms.forEach(alarm => {
                alarms.push(alarm)
            });
        });
    });
    return alarms;
}
function getEquipmentAlarms(id, plantId, alarmsReceived) {
    let plant
    let equipmentsAlarms = []
    plant = alarmsReceived.find(e => e.id == plantId)
    if (plant) {
        let equipmentAlarm = plant.equipments.find(e => e.id == id)
        if (equipmentAlarm) {
            equipmentAlarm.alarms.forEach(element => {
                equipmentsAlarms.push(element)
            });
        }
    }

    return equipmentsAlarms

}

const alarmState = {
    state: {
        _alarmsReceived: [],
        _activedAlarmIntervalFlag: false,
        _updatedTime: moment().format("HH:mm:ss DD/MM/YYYY"),
        _showAlarms: false
    },
    getters: {
        alarmsReceived(state) {
            return state._alarmsReceived;
        },
        activedAlarmIntervalFlag(state) {
            return state._activedAlarmIntervalFlag;
        },
        updatedTime(state) {
            return state._updatedTime;
        },
        showAlarms(state) {
            return state._showAlarms
        }

    },
    mutations: {
        setAlarmsReceived(state, data) {
            state._alarmsReceived = data;
        },
        setActivedAlarmIntervalFlag(state) {
            state._activedAlarmIntervalFlag = true;
        },
        setUpdatedTime(state) {
            state._updatedTime = moment().format("HH:mm:ss DD/MM/YYYY");
        },
        activeAlarms(state) {
            state._showAlarms = true;
        }
    },
    actions: {
        setAlarms({ commit, getters }, alarms) {
            const { activedAlarmIntervalFlag } = getters
            if (!activedAlarmIntervalFlag) commit("setActivedAlarmIntervalFlag")
            commit('setAlarmsReceived', alarms)
        },
        // if has a plantId,means this is an equipment.
        getAlarms({ getters }, { id, plantId }) {
            const { alarmsReceived } = getters;
            if (!plantId) {
                return getPlantAlarms(id, alarmsReceived)
            }
            else {
                return getEquipmentAlarms(id, plantId, alarmsReceived)
            }

        },
        getTotal({ getters }, { id, plantId }) {
            const { alarmsReceived, activedAlarmIntervalFlag } = getters;
            if (alarmsReceived.length) {
                let totalAlarms = plantId ? getEquipmentAlarms(id, plantId, alarmsReceived) : getPlantAlarms(id, alarmsReceived)
                return getPriorityQuantityTotal(totalAlarms)
            }
            else if (activedAlarmIntervalFlag) return { high: 0, medium: 0, low: 0 };

            return;
        },
        setTime({ commit }) {
            commit('setUpdatedTime')
        },
        setShowAlarms({ commit }) {
            commit("activeAlarms")
        }

    }
};


export default alarmState;
